import React from 'react';

export default function CurrencyConversionPanel({ amountUsd, paystackQuote, compact }) {
  if (!paystackQuote?.amount_display || amountUsd == null) {
    return (
      <div className="rounded-lg bg-slate-50 border border-slate-200 px-3 py-3 text-sm text-slate-600">
        Live ZAR conversion will appear once your order is ready.
      </div>
    );
  }

  const rate = paystackQuote.fx_rate;
  const rateLabel =
    rate != null && Number.isFinite(Number(rate))
      ? Number(rate).toLocaleString('en-ZA', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
          useGrouping: false,
        })
      : null;

  return (
    <div
      className={`rounded-xl border border-emerald-100 bg-gradient-to-br from-emerald-50/80 to-slate-50 px-4 py-3.5 ${
        compact ? '' : 'shadow-sm'
      }`}
    >
      <p className="text-xs font-semibold uppercase tracking-wide text-emerald-800 mb-2">
        Live currency conversion
      </p>
      <dl className="space-y-2 text-sm">
        <div className="flex items-center justify-between gap-3">
          <dt className="text-slate-600">Plan price</dt>
          <dd className="font-semibold text-slate-900">${Number(amountUsd).toFixed(2)} USD</dd>
        </div>
        {rateLabel ? (
          <div className="flex items-center justify-between gap-3">
            <dt className="text-slate-600">Exchange rate</dt>
            <dd className="font-medium text-slate-800">1 USD = R{rateLabel}</dd>
          </div>
        ) : null}
        <div className="flex items-center justify-between gap-3 pt-2 border-t border-emerald-100">
          <dt className="text-slate-700 font-medium">You pay on Paystack</dt>
          <dd className="text-lg font-bold text-emerald-900">{paystackQuote.amount_display}</dd>
        </div>
      </dl>
      <p className="mt-2.5 text-[11px] leading-relaxed text-slate-500">
        Final ZAR amount is confirmed on Paystack&apos;s secure payment page.
      </p>
    </div>
  );
}
